import { useQuery } from '@tanstack/react-query';
import { permissionApi } from '../api';
import { PERMISSION_KEYS } from '../lib';
import { useAuthStore } from '@/shared/lib';

export const usePermissions = () => {
  const setPermissions = useAuthStore((state) => state.setPermissions);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return useQuery({
    queryKey: PERMISSION_KEYS.index(),
    queryFn: async () => {
      const response = await permissionApi.getPermissions();
      
      if (response.success && response.result) {
        setPermissions(response.result);
      }
      
      return response;
    },
    enabled: isAuthenticated,
    staleTime: Infinity,
    gcTime: Infinity,
  });
};
